import { useEffect, useRef, useState } from 'react';
import { isCleared } from '../helpers/levels';
import type { TIssuedRewards } from '../helpers/rewardBonus';
import type { ILevel } from '../types';

/**
 * Order of the level that has just cleared and is still waiting for its reward.
 */
export const useSettlingReward = (
  levels: ILevel[],
  issuedRewards: TIssuedRewards
): number | null => {
  const [justCleared, setJustCleared] = useState<number | null>(null);
  const previousCleared = useRef<number[] | null>(null);

  useEffect(() => {
    const cleared = levels.filter(isCleared).map(({ order }) => order);
    const previous = previousCleared.current;

    previousCleared.current = cleared;

    // the first pass is the state on arrival, nothing cleared just now
    if (!previous) return;

    const fresh = cleared.filter((order) => !previous.includes(order));

    if (fresh.length > 0) setJustCleared(Math.max(...fresh));
  }, [levels]);

  // the reward arriving ends the wait, no need to track that in state
  return justCleared !== null && !issuedRewards.has(justCleared)
    ? justCleared
    : null;
};
